/* src/app/pages/results/comparative-report/comparative-reports.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: flex;
  flex-direction: column;
  padding: 32px 24px;
}
:host ::ng-deep bfm-monthly-comparative {
  padding: 24px 16px !important;
  background: var(--cds-background-main);
  border-radius: 4px;
  margin: 24px 0px;
}
:host ::ng-deep bfm-comparative-filter header {
  width: 70%;
  justify-content: unset !important;
  display: inline-flex !important;
}
:host ::ng-deep bfm-comparative-filter header section {
  gap: 12px !important;
}
:host ::ng-deep bfm-comparative-filter header section label {
  color: var(--cds-text-strong) !important;
  font-weight: 600 !important;
  font-size: 16px !important;
}
:host ::ng-deep bfm-comparative-filter header section div:nth-child(2) {
  gap: 12px !important;
}
:host ::ng-deep bfm-comparative-filter .comparative-header-fixed {
  position: fixed;
  top: 0px;
  width: 100%;
  left: 0;
  height: 120px;
  background: var(--cds-card-background);
  display: flex;
  box-shadow: 3px 2px 3px 2px color-mix(in srgb, var(--cds-text-light) 30%, transparent);
  z-index: 1006;
  padding: 10px 0 10px 35px;
}
:host ::ng-deep cds-dropdown input {
  max-width: 160px !important;
}
:host ::ng-deep cds-input-wrapper fieldset {
  display: inline;
}
:host ::ng-deep cds-cost-center-input input {
  max-width: 225px !important;
}
:host ::ng-deep bfm-date-range label {
  color: var(--cds-text-strong) !important;
  font-weight: 600 !important;
  font-size: 16px !important;
}
:host ::ng-deep bfm-date-range input {
  max-width: 100px !important;
}
:host ::ng-deep bfm-comparative-header {
  vertical-align: bottom;
}
:host ::ng-deep bfm-comparative-header .default-flex-between {
  justify-self: end !important;
  width: 30%;
  display: inline-flex;
  justify-content: flex-end;
}
:host ::ng-deep bfm-comparative-header .default-flex-between .eye-button-line {
  flex-direction: column-reverse;
  place-items: self-end;
  gap: 15px;
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-comparative-header .default-flex-between .eye-button-line .cds-button.s-plain {
  padding-right: unset;
}
:host ::ng-deep bfm-comparative-header .default-flex-between div > button:nth-child(2) {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: 600;
  color: var(--cds-primary-500);
  line-height: 1.5;
}
:host ::ng-deep .report > div {
  gap: 4px !important;
}
:host ::ng-deep cds-placeholder-shimmer {
  margin-top: 20px !important;
}
:host ::ng-deep cds-placeholder-shimmer .shimmer .content {
  margin: unset !important;
  height: 1216px !important;
}
:host ::ng-deep bfm-comparative-table {
  margin-top: 20px;
  overflow: unset;
}
:host ::ng-deep bfm-comparative-table .table {
  box-shadow: none !important;
  border-radius: 0 !important;
}
:host ::ng-deep bfm-comparative-table .table .column {
  margin-right: 4px !important;
}
:host ::ng-deep bfm-comparative-table .table .column label {
  border-radius: 4px 4px 0 0 !important;
  margin-bottom: 4px;
  background: var(--cds-background-accent) !important;
  color: var(--cds-text-strong) !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
}
:host ::ng-deep bfm-comparative-table .table .column .item {
  margin-bottom: 12px;
  border: none !important;
  border-radius: 4px;
  max-height: 80px;
}
:host ::ng-deep bfm-comparative-table .table .column .item .upper-row {
  justify-content: unset;
  gap: 10px;
}
:host ::ng-deep bfm-comparative-table .table .column .item .upper-row h5 {
  font-weight: 700;
}
:host ::ng-deep bfm-comparative-table .table .column .item .upper-row > .result,
:host ::ng-deep bfm-comparative-table .table .column .item .upper-row .sum {
  color: var(--cds-text-medium) !important;
  font-weight: 400 !important;
  font-size: 16px !important;
}
:host ::ng-deep bfm-comparative-table .table .column .item:nth-child(odd) {
  background: var(--cds-background-accent) !important;
}
:host ::ng-deep bfm-comparative-table .table .column .item:nth-child(even) {
  background: var(--cds-foreground-20) !important;
}
:host ::ng-deep bfm-comparative-table:nth-of-type(2) {
  overflow: hidden;
}
/*# sourceMappingURL=comparative-reports.component.css.map */
